module.exports = __webpack_public_path__ + "img/ashcode.f405aa2d.jpg";